import { render, staticRenderFns } from "./PayRangeDetailPage.vue?vue&type=template&id=3405fa91&scoped=true"
import script from "./PayRangeDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeDetailPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeDetailPage.vue?vue&type=style&index=0&id=3405fa91&prod&scoped=true&lang=css"
import style1 from "./PayRangeDetailPage.vue?vue&type=style&index=1&id=3405fa91&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405fa91",
  null
  
)

export default component.exports